import React, { useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import {
  CONTACT_CHANNELS_UPDATED_EVENT,
  getWhatsAppChatHelpUrl,
} from '../utils/whatsappContact';
import './FloatingWhatsAppButton.css';

/** Pixels from document bottom — user neeche scroll kare tab dikhe */
const NEAR_BOTTOM_PX = 360;
/** Chhoti page jahan scroll kam ho */
const SHORT_PAGE_EXTRA_PX = 72;

export default function FloatingWhatsAppButton() {
  const location = useLocation();
  const [contactTick, setContactTick] = useState(0);
  const [nearBottom, setNearBottom] = useState(false);

  useEffect(() => {
    const bump = () => setContactTick((t) => t + 1);
    window.addEventListener(CONTACT_CHANNELS_UPDATED_EVENT, bump);
    window.addEventListener('storage', bump);
    return () => {
      window.removeEventListener(CONTACT_CHANNELS_UPDATED_EVENT, bump);
      window.removeEventListener('storage', bump);
    };
  }, []);

  const waUrl = useMemo(
    () => getWhatsAppChatHelpUrl(),
    [contactTick, location.pathname]
  );

  useEffect(() => {
    const check = () => {
      const docEl = document.documentElement;
      const scrollTop = window.scrollY ?? docEl.scrollTop;
      const winH = window.innerHeight;
      const fullH = Math.max(
        docEl.scrollHeight,
        document.body?.scrollHeight ?? 0
      );
      if (fullH <= winH + SHORT_PAGE_EXTRA_PX) {
        setNearBottom(true);
        return;
      }
      setNearBottom(scrollTop + winH >= fullH - NEAR_BOTTOM_PX);
    };

    check();
    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check);
    return () => {
      window.removeEventListener('scroll', check);
      window.removeEventListener('resize', check);
    };
  }, [location.pathname]);

  if (!waUrl) return null;

  return (
    <a
      href={waUrl}
      target="_blank"
      rel="noopener noreferrer"
      className={`floating-wa-chat ${nearBottom ? 'floating-wa-chat--visible' : ''}`}
      aria-label="Chat on WhatsApp"
      title="Chat on WhatsApp"
    >
      <i className="fab fa-whatsapp" aria-hidden />
    </a>
  );
}
